const en = {
  General: {
    why: () => 'why should I do this?',
    help: () => '',
    cancel: () => 'Cancel'
  },
  Home: {
    ProcessingBar: {
      processingText: {
        processingTeamMembers: () => 'Looking for your team members...',
        processingRepos: () => 'Processing your repositories...'
      },
      text: {
        processingContributors: () => 'Welcome to LinearB',
        connectPM: {
          default: () =>
            'Get much more out of LinearB - Connect your project management tool:',
          processing: () =>
            'While we process - Connect your project management tool:'
        },
        connectJiraBoard: {
          default: () =>
            'Get much more out of LinearB by connecting your team’s Jira board',
          processing: () =>
            'Select your Jira board so we can show you the right stories'
        },
        connectClubhouseProject: {
          default: () =>
            'Get much more out of LinearB by connecting your team’s Shortcut project',
          processing: () =>
            'Select your Shortcut project so we can show you the right stories'
        },
        allConnected: {
          default: () =>
            'Looks like you’re almost set up, it could take a while to process your data...'
        },
        processingRepos: () => 'Your new repositories will be ready soon'
      },
      jiraButton: {
        connect: () => 'Jira',
        select: () => 'Select Board'
      },
      clubhouseButton: {
        connect: () => 'Shortcut',
        select: () => 'Select Project'
      },
      azureBoardsButton: {
        connect: () => 'Azure Boards',
        select: () => 'Select Project'
      }
    }
  },
  Setting: {
    Slack: {
      reauthorize: {
        successNotificationExistingSlackAccount: () =>
          'You’ve successfully reauthorized Slack',
        reauthorizeText: () => 'Reauthorize Slack',
        reauthorizeTooltipTitle: () => 'What’s new on our Slack app',
        personalNotificationBulletTitleText: () => 'Personal notifications',
        personalNotificationBulletContentText: () =>
          'notify each member about their own blocked work',
        slackCommandBulletTitleText: () => 'Slash commands',
        learnMoreText: () => 'learn more about notifications',
        slackCommandBulletContentText: () => 'get info whenever you need it',
        reauthorizeTooltipContent: () =>
          'this will update the LinearB Slack app to the newest version',
        reAuthorizeAnotherAccountTooltipText: () =>
          'Connect a different Slack account or reauthorize this account (this will reset all team settings and you will need to configure them from scratch)',
        newConnectionModal: {
          approveButton: () => 'Contact Support'
        },
        contactAdminForReAuth:
          'Contact your LinearB admin to reauthorize Slack',
        contactSupportText: () => 'Contact support',
        reAuthorizeMissingScopeText: () => 'Personal Notifications are here!',
        upgradeYourSlackText: () => 'Upgrade your Slack app',
        reAuthorizeInvalidTokenText: () =>
          'Something went wrong with your Slack connection'
      }
    }
  },
  Dashboard: {
    Notifications: {
      SlackReAuthCallToAction: {
        titleText: () => 'Update your Slack app!',
        descriptionText: () =>
          'for your teams to enjoy personal notifications, slash commands and flexibility to control which notifications they receive.',
        reAuthorizeButtonText: () => 'Reauthorize Slack',
        learnMoreText: () => 'Learn more'
      }
    }
  }
};

export default en;
